import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AppTab } from '../../core/app-tab';
import { AppState, ShowRequest } from "../../core"
import { PostProcessingService } from '../../core/services';
import { CorrelationDashboardTableComponent } from './correlation-dashboard-table.component';
import { CorrelationDashboardRecord } from '../../core/models';

@Component({
  selector: 'app-correlation-dashboard',
  templateUrl: './correlation-dashboard.component.html',
  styleUrls: ['./correlation-dashboard.component.scss']
})
export class CorrelationDashboardComponent implements OnInit {

  //
  // These @Input values get passed in from home.html
  // The table in correlation-dashboard.component.html uses them
  //

  @Input() tabConfig: AppTab;

  @Input() detailFn: (vi: ShowRequest) => void;

  @Input('isActiveView') set isActiveViewSet( bActive: boolean ) {
    this.isActiveView = bActive
    if ( bActive && this.dashboardTable?.records?.length > 0 ) {
      this.appState.webSocketSubject.next({
        message: { type: 'activeJobs' },
        accessToken: this.appState.getUser()?.token
      });
    }
  }
  isActiveView: boolean;

  @Input() contextJson: string;

  @Input() contextJsonChangeHandler : (itemId: string,tab:AppTab) => void

  @ViewChild('dashboardTable') dashboardTable: CorrelationDashboardTableComponent;

  downloadRollupSummLoading = false;
  distinctParticipants: string[] = [];
  selectedParticipant: string;
  participantStages: string[] = [];
  selectedParticipantStage: string;

  constructor(
    public appState: AppState,
    public postProcessingService: PostProcessingService,
  ) { }

  ngOnInit(): void {
  }

  onTableLoaded = async (rows: CorrelationDashboardRecord[]) => {
    await this.initDistinctParticipants();
    // every time table data is reloaded, request all activeJobs
    this.appState.webSocketSubject.next({
      message: { type: 'activeJobs' },
      accessToken: this.appState.getUser()?.token
    });
  }

  async initDistinctParticipants() {
    try {
      const participants = await this.postProcessingService.correlationDashboardDistinctParticipants();
      this.distinctParticipants = participants;
    } catch (e:any) {
      this.dashboardTable.reportErrorFn(e);
    }
  }

  async changeParticipant(participant: string) {
    try {
      this.selectedParticipant = participant;
      this.participantStages = participant ?
        await this.postProcessingService.correlationDashboardDistinctParticipantStages(participant) : []
    } catch (e:any) {
      this.dashboardTable.reportErrorFn(e);
    }
  }

  async changeParticipantStage(value: string) {
    this.selectedParticipantStage = value;
  }

  rollupSummaryReportXLWbk = async () => {
    this.downloadRollupSummLoading = true;
    const queryParams = {
      stage: this.selectedParticipantStage,
      participant: this.selectedParticipant,
    };

    try {
      await this.postProcessingService.downloadRollupSummary(queryParams);
    } catch (error) {
      console.error(error);
      this.dashboardTable.errorMsg = `Error generating ${
        this.selectedParticipant
      } ${this.selectedParticipantStage} Rollup Summary Workbook. ${this.postProcessingService.extractErrorMsg(
        error
      )}`;
    } finally {
      this.downloadRollupSummLoading = false;
    }
  };

}
